import apiService from '@/api/apiService';

export const getRole = async (roleId) => {
    const url = `/api/admin/roles/${roleId}`;

    return apiService.GET(url);
};
